import { render, staticRenderFns } from "./continuities-table.vue?vue&type=template&id=28894fd1"
import script from "./continuities-table.vue?vue&type=script&lang=js"
export * from "./continuities-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports